import React, {useState, useEffect} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";

import RcaItemsCard from "components/Rca/RcaItemsCard";
import ActionItemDetails from "./ActionItemDetails";
import SideBar from "../../components/HorizontalLayout/Sidebar";

const Rca = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const actionItemId = queryParams.get('actionItemId');

  const [currentTab, setCurrentTab] = useState("RCA");

  const setCurrentTabLink = (tab) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', tab);
    navigate(`?${searchParams.toString()}`);
  };

  return (
    <React.Fragment>
      {actionItemId ?
          <div className="d-flex justify-content-center mt-2">
            <ActionItemDetails actionItemId={actionItemId}/>
          </div> :
          <div>
            <SideBar current_page={"Incident Management"}/>
            <div className="w-80 mt-2" style={{marginLeft: '18%', marginRight: '4%'}}>
              <div className="mt-4">
                <h4>Root Cause Analysis</h4>
                <div className="d-flex justify-content-between mt-4">
                  <div>
                    <ul className="nav-tabs-custom nav-justified nav nav-tabs">
                      <li className="nav-item" onClick={() => {
                        setCurrentTab("RCA")
                        setCurrentTabLink("RCA")
                      }}>
                        <a className={`nav-link ${currentTab === "RCA" ? 'active' : null}`}>RCA</a>

                      </li>
                      <li className="nav-item text-nowrap" onClick={() => {
                        setCurrentTab("Action Items")
                        setCurrentTabLink("ActionItems")
                      }}>

                        <a className={`nav-link ${currentTab === "Action Items" ? 'active' : null}`}>
                          Action Items
                        </a>
                      </li>
                    </ul>
                  </div>
                  <Link to="/rca-form">
                    <button className="btn btn-primary">Create RCA</button>
                  </Link>
                </div>
                <div className="mt-4">
                  <RcaItemsCard currentTab={currentTab}/>
                </div>
              </div>
            </div>
          </div>
      }

          </React.Fragment>
        )
      }

      export default Rca;